import styled from "styled-components";
import { Divider, Flex, FlexSpan } from "@evergis/ui";

import { BlockTitle } from "../styled";

export const AttributesBlockTitle = styled(BlockTitle)`
  justify-content: space-between;
`;

export const AttributesBlockCheckbox = styled(Flex)`
  margin-left: 3.25rem;
  margin-top: 1.5rem;
`;

export const AddSystemAttributesLabel = styled(FlexSpan)<{ disabled?: boolean }>`
  color: ${({ disabled, theme: { palette } }) => (disabled ? palette.iconDisabled : palette.icon)};
  margin-left: 0.5rem;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  &:hover {
    color: ${({ disabled, theme: { palette } }) => (disabled ? palette.iconDisabled : palette.iconAccent)};
  }
`;

export const ToggleVisibilityLabel = styled.label`
  position: absolute;
  left: 2.5rem;
  white-space: nowrap;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const StickyShadowHide = styled.div`
  position: absolute;
  z-index: 2;
  background-color: ${({ theme: { palette } }) => palette.element};
  width: 100%;
  height: 1px;
  bottom: 4rem;
`;

export const AttributesActionsContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  position: sticky;
  z-index: 1;
  bottom: 0;
  width: 100%;
  background-color: ${({ theme: { palette } }) => palette.background};
  box-shadow: 0 -1px 0 0 ${({ theme: { palette } }) => palette.elementDeep};
  margin-top: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const ActionsDivider = styled(Divider)`
  height: 1rem;
  margin-top: 0.5rem;
`;

export const AttributesTabs = styled(Flex)`
  align-items: center;
  width: 100%;
  margin-top: 1rem;
  margin-left: 2rem;
`;

export const TableReferencesActions = styled(Flex)`
  align-items: center;
  margin-left: auto;
  font-size: 0.75rem;
`;
